/**
* @license Apache-2.0
*
* Copyright (c) 2023 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MAIN //

/**
* Replaces the substring before the first occurrence of a specified search string.
*
* @param {string} str - input string
* @param {string} search - search string
* @param {string} replacement - replacement string
* @returns {string} string
*
* @example
* var out = replaceBefore( 'beep boop', ' ', 'foo' );
* // returns 'foo boop'
*
* @example
* var out = replaceBefore( 'beep boop', 'p', 'foo' );
* // returns 'foop boop'
*
* @example
* var out = replaceBefore( 'Hello World!', '', 'foo' );
* // returns 'Hello World!'
*
* @example
* var out = replaceBefore( 'Hello World!', 'xyz', 'foo' );
* // returns 'Hello World!'
*/
function replaceBefore( str, search, replacement ) {
	var idx = str.indexOf( search );
	if ( str === '' || search === '' || replacement === '' || idx < 0 ) {
		return str;
	}
	return replacement + str.substring( idx );
}


// EXPORTS //

export default replaceBefore;
